module.exports = __webpack_public_path__ + "static/img/google_btn.7cb9c1d6.png";